<template>
    <div id="block_settings_page_container" style="width: 100%; min-height: 100vh; overflow: auto"></div>
</template>

<script>
import { BACKEND_BASE_URL } from '@/config';
export default {
    mounted() {
        try {
            fetch(BACKEND_BASE_URL + '/module_mantainer/block_settings.php').then(async response => {
                let page_content = await response.text();

                document.getElementById('block_settings_page_container').innerHTML = page_content;
                this.nodeScriptReplace(document.getElementById('block_settings_page_container'));
            })
        } catch (e) {
            alert('Impossibile caricare la pagina');
        }
    },
    methods: {
        nodeScriptReplace(node) {
            if (this.nodeScriptIs(node) === true) {
                node.parentNode.replaceChild(this.nodeScriptClone(node), node);
            }
            else {
                var i = -1, children = node.childNodes;
                while (++i < children.length) {
                    this.nodeScriptReplace(children[i]);
                }
            }

            return node;
        },
        nodeScriptClone(node) {
            var script = document.createElement("script");
            script.text = node.innerHTML;

            var i = -1, attrs = node.attributes, attr;
            while (++i < attrs.length) {
                script.setAttribute((attr = attrs[i]).name, attr.value);
            }
            return script;
        },

        nodeScriptIs(node) {
            return node.tagName === 'SCRIPT';
        }
    }
}
</script>
